import * as React from "react";
import { observer } from "mobx-react";
import { Button } from "./../Button";
import { Strings } from "../../Stores/StringsStore";

@observer
export class PagePreviousButton extends Button {

	render() {
		return <Button {...this.props} title={this.props.title ? this.props.title : Strings.reader.pagePreviousButtonTooltip}>
			<i>
				<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
					<path d="M16,0A16,16,0,1,0,32,16,16,16,0,0,0,16,0ZM26,18H13.66l5.07,5.07L15.9,25.9,8.83,18.83,6,16l2.83-2.83L15.9,6.1l2.83,2.83L13.66,14H26v4Z" />
				</svg>
			</i>
		</Button>;
	}
}
